import React, { Component } from 'react';
import $ from 'jQuery';
import { Carousel } from 'react-responsive-carousel';
import Slider from 'react-image-slider';

export default class Home extends Component {

    componentDidMount() {

    }
    render() {

        const images = [
            '../assets/images/portfolio/img1.jpg',
            '../assets/images/portfolio/img2.jpg',
            '../assets/images/portfolio/img3.jpg',
            '../assets/images/portfolio/img4.jpg',
            '../assets/images/portfolio/img5.jpg',
        ];

        return (
            <div className="container topOffset">
                {/* <Slider images={images} isInfinite delay={5000}>
        {images.map((image, key) => <div key={key}><img src={image} /></div>)}
      </Slider> */}

                <Carousel autoPlay={true} interval={2000} infiniteLoop={true} emulateTouch={true} dynamicHeight={false}>
                    <div>
                        <img src="../assets/images/portfolio/img1.jpg" />
                        {/* <p className="legend">Legend 1</p> */}
                    </div>
                    <div>
                        <img src="../assets/images/portfolio/img2.jpg" />
                        {/* <p className="legend">Legend 2</p> */}
                    </div>

                    <div>
                        <img src="../assets/images/portfolio/img4.jpg" />
                        {/* <p className="legend">Legend 3</p> */}
                    </div>
                    <div>
                        <img src="../assets/images/portfolio/img5.jpg" />
                        {/* <p className="legend">Legend 3</p> */}
                    </div>
                    <div>
                        <img src="../assets/images/portfolio/img6.jpg" />
                        {/* <p className="legend">Legend 3</p> */}
                    </div>
                    <div>
                        <img src="../assets/images/portfolio/img7.jpg" />
                        {/* <p className="legend">Legend 3</p> */}
                    </div>
                    <div>
                        <img src="../assets/images/portfolio/img8.jpg" />
                        {/* <p className="legend">Legend 3</p> */}
                    </div>
                    <div>
                        <img src="../assets/images/portfolio/img9.jpg" />
                        {/* <p className="legend">Legend 3</p> */}
                    </div>
                    <div>
                        <img src="../assets/images/portfolio/img10.jpg" />
                        {/* <p className="legend">Legend 3</p> */}
                    </div>
                </Carousel>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./app/screens/Home/index.js